export default function (size: number | null | undefined, unit: string = 'B', gigaUnit: string = 'G'): string {
    if (!size && size !== 0) {
        return '';
    }

    const formatter = new Intl.NumberFormat('en-US', {
        maximumSignificantDigits: 2,
    });

    if (size >= 1000000000) {
        return formatter.format(size / 1000000000) + ' ' + gigaUnit + unit;
    }

    if (size >= 1000000) {
        return formatter.format(size / 1000000) + ' M' + unit;
    }

    if (size >= 1000) {
        return formatter.format(size / 1000) + ' k' + unit;
    }

    return size + ' ' + unit;
}
